module.exports = __webpack_public_path__ + "img/message-text.51d732ea.svg";